import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpClientModule} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Libro } from '../modelos/libro';

@Injectable({
    providedIn: 'root'
  })
  export class CaptchaService {
  
    
    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      }
  
    constructor(private http:HttpClient) {
  
        
    }

    
    GetCaptcha():any{

    return this.http.get<any>(environment.URL_BACKEND + 'Captcha/get-captcha/',this.httpOptions)
        .pipe(
        retry(1),
        catchError(this.errorHandl)
        )

    }




    errorHandl(error) {
      let errorMessage = '';
      if(error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      console.log(errorMessage);
      return throwError(errorMessage);
    }
     


}